import { InjectionToken } from '@angular/core';

export interface RecaptchaConfig {
  siteKey: string;
  enabled: boolean;
}

export const RECAPTCHA_CONFIG = new InjectionToken<RecaptchaConfig>('RECAPTCHA_CONFIG');
